/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_BackInputs */



/**
* | output |
* | --- |
* | "Back to members" |
*
* @param {Team_Manager_Import_BackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_back = /** @type {((inputs?: Team_Manager_Import_BackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_BackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour aux membres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zu den Mitgliedern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna ai membri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назад к участникам")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver a miembros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバーに戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यों पर वापस जाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar aos membros")
	return /** @type {LocalizedString} */ ("Back to members")
});